module.exports = __webpack_public_path__ + "img/SC5-Income_&_savings.01e4956a.svg";